export default __webpack_public_path__ + "static/media/notification-status-green.7cc16936.svg";